import { Kiosk } from "domains/kiosk/aggregates/Kiosk";
import { PixKind } from "modules/payment/domain/models/PixApprovedTransaction";
import { TransactionType } from "modules/payment/domain/models/TransactionType";

// Regra única de emissão de NFC-e após o pagamento (o valor > 0 é checado pelo chamador)
export const shouldEmitNfce = (
  kiosk: Kiosk,
  recharge: PixKind | undefined,
  transactionType: TransactionType
): boolean => {
  const isTransaction =
    transactionType === TransactionType.credit ||
    transactionType === TransactionType.debit ||
    transactionType === TransactionType.pix ||
    transactionType === TransactionType.voucher;

  const isRecharge = recharge === "Recharge";

  return !!(
    kiosk.generateEletronicInvoice &&
    ((!kiosk.generateEletronicInvoiceForRecharge && !isRecharge) ||
      (kiosk.generateEletronicInvoiceForRecharge && isTransaction)) &&
    recharge !== "WalletRecharge"
  );
};
